import { PropsWithChildren } from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

export const RegularText = (
  props: PropsWithChildren<{ className?: string }> & { size?: number }
): JSX.Element => (
  <span
    style={{
      fontSize: props.size || 12,
    }}
    className={cn(styles.regularText, props.className)}
  >
    {props.children}
  </span>
);
